import React from 'react';
import NHLGameLogViewer from './components/NHLGameLogViewer';
import './index.css';

function App() {
  return (
    <div className="App">
      <NHLGameLogViewer />
    </div>
  );
}

export default App;
